import type { Communication } from '@medplum/fhirtypes';
import { createContext, useContext } from 'react';

export type FhirRealtimeRefreshHandler = () => void;
export type FhirRealtimeNotificationHandler = (comm: Communication) => void;

export interface FhirRealtimeContextValue {
  onNotificationRefresh: (handler: FhirRealtimeRefreshHandler) => () => void;
  onNotificationReceived: (handler: FhirRealtimeNotificationHandler) => () => void;
  onClientPortalRefresh: (handler: FhirRealtimeRefreshHandler) => () => void;
  notificationsConnected: boolean;
  clientPortalConnected: boolean;
}

export const FhirRealtimeContext = createContext<FhirRealtimeContextValue | null>(null);

export function useFhirRealtimeOptional(): FhirRealtimeContextValue | null {
  return useContext(FhirRealtimeContext);
}

export function useFhirRealtime(): FhirRealtimeContextValue {
  const ctx = useFhirRealtimeOptional();
  if (!ctx) {
    throw new Error('useFhirRealtime must be used inside FhirRealtimeProvider');
  }
  return ctx;
}
